import { render } from "./SelecionarPessoaFisica.vue?vue&type=template&id=f146d9c4"
import script from "./SelecionarPessoaFisica.vue?vue&type=script&lang=js"
export * from "./SelecionarPessoaFisica.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__